module.exports = __webpack_public_path__ + "img/violet_090.0f06330f.png";